import { Pill } from "@clipboard-health/ui-components";

type StatusPillVariant = "success" | "neutral";

interface StatusPillProps {
  readonly label: string;
  readonly variant: StatusPillVariant;
}

export function StatusPill({ label, variant }: StatusPillProps) {
  return (
    <Pill
      label={label}
      size="small"
      backgroundColor={(theme) =>
        variant === "success" ? theme.palette.success.light : theme.palette.grey[200]
      }
      color={(theme) =>
        variant === "success" ? theme.palette.success.contrastText : theme.palette.text.secondary
      }
    />
  );
}
